/* ==========================================================================
   WADES — alarm.js
   Loaded only on the alarm product template, after belt.js. belt.js already
   runs the gallery, the bundle picker, the sticky bar, the accordions and the
   reviews on this page; this file adds only what the alarm page has that the
   belt page does not.
   ========================================================================== */
(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion:reduce)').matches;
  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  /* ============================================================
     1. AMBIENT VIDEOS — the vibration clip in the benefits section.
        preload="none" in the markup; nothing is fetched until the clip is
        near the screen, and it stops the moment it leaves.
     ============================================================ */
  (function () {
    var vids = qsa('[data-alarm-video]');
    if (!vids.length) return;

    function play(v) {
      if (v.preload === 'none') { v.preload = 'auto'; v.load(); }
      var p = v.play();
      if (p && p.catch) p.catch(function () {});
    }
    if (!('IntersectionObserver' in window)) { vids.forEach(play); return; }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) play(en.target); else en.target.pause();
      });
    }, { threshold: 0.3 });
    vids.forEach(function (v) { io.observe(v); });
  })();

  /* ============================================================
     2. BENEFIT PINS — draw in one by one as the section arrives.
        The stagger is in CSS (--i on each pin); this only flips the class.
     ============================================================ */
  (function () {
    var orbits = qsa('[data-alarm-orbit]');
    if (!orbits.length) return;
    if (reduced || !('IntersectionObserver' in window)) {
      orbits.forEach(function (o) { o.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        en.target.classList.add('is-in');
        io.unobserve(en.target);
      });
    }, { threshold: 0.22 });
    orbits.forEach(function (o) { io.observe(o); });
  })();

  /* ============================================================
     3. DEAL BANNER — jump to the picker (belt.js does the scrolling on the
        same click) and land on the tier the banner advertised, so a visitor
        who tapped "choose the 2-pack" is not left looking at the single.
     ============================================================ */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-belt-jump-tier]');
    if (!t) return;
    var n = t.getAttribute('data-belt-jump-tier');
    var head = qs('[data-belt-tier="' + n + '"] [data-belt-tier-head]');
    if (head) head.click();
  });

  /* ============================================================
     4. "GOES WELL WITH" — after a one-tap add the row says so, so the
        visitor is not left wondering whether the tap registered. theme.js
        owns the request; this only reacts to the button it re-enables.
     ============================================================ */
  (function () {
    var rail = qs('[data-alarm-pairs]');
    if (!rail) return;
    rail.addEventListener('submit', function (e) {
      var form = e.target.closest('form[data-ajax-cart]');
      if (!form) return;
      var row = form.closest('.pair');
      if (row) row.classList.add('is-added');
    });
  })();
})();
